import { useTranslation } from 'react-i18next';
import { Card, EmptyState, LoadingState } from '@/components/ui';
import { useSession } from '@/features/auth/session-context';
import { usePanelLimitConfigurations } from '@/features/panel-limits/api';
import { PageContainer } from '@/layouts/PageContainer';
import { ErrorMessage, PanelLimitEditor } from './PanelContractLimits';
import styles from './PanelLimits.module.css';

/**
 * "Panel limit configuration" (RL-1057 / RL-1511): every panel's per-visit,
 * annual and warning-threshold limits in one place. Anyone with panels:read
 * sees the values; only panels:manage (Finance) gets the editor, matching the
 * API (GET needs panels:read, PATCH needs panels:manage).
 */
export function PanelLimitConfigurationPage() {
  const { t } = useTranslation();
  const { hasPermission } = useSession();
  const canManage = hasPermission('panels:manage');
  const configurations = usePanelLimitConfigurations();

  return (
    <PageContainer>
      <p className={styles.note}>{t('panelLimits.configurationNote')}</p>
      {configurations.isLoading ? (
        <LoadingState />
      ) : configurations.error ? (
        <ErrorMessage error={configurations.error} />
      ) : !configurations.data?.length ? (
        <EmptyState
          title={t('panelLimits.noConfigurations')}
          body={t('panelLimits.noConfigurationsBody')}
        />
      ) : (
        configurations.data.map((configuration) => (
          <Card key={configuration.id} title={configuration.panelName}>
            <PanelLimitEditor
              key={configuration.updatedAt}
              configuration={configuration}
              canManage={canManage}
            />
          </Card>
        ))
      )}
    </PageContainer>
  );
}
